import request from '@/utils/request.js'
import main from '@/main'

const basePath = '/Function/Product/Line/Team/';

const state = {
  PriceType: {
    "A00": "基本价",
    "A01": "儿童价",
    "A02": "成人不占床价格",
    "A03": "补房差",
    "A04": "导游小费",
    "A05": "签证费",
    "A06": "其他费用",
    "A07": "同行基本价",
    "A08": "同行儿童价",
    "A09": "同行成人不占床价",
    "A010": "高铁半票",
    "A011": "外宾价格",
    "A012": "不送礼价",
    "A013": "外籍护照附加费",
    "A014": "离境税",
    "A015": "老人附加费",
    "A016": "港务费",
    "A017": "12-18岁占床",
    "A018": "12岁以上占床",
    "A019": "6岁以上占床",
    "A020": "特殊报价1",
    "A021": "特殊报价2",
    "A022": "特殊报价3",
    "A023": "特殊报价4",
    "A024": "特殊报价5",
    "A025": "特殊报价6",
    "A026": "特殊报价7",
    "A027": "特殊报价8",
    "A028": "特殊报价9",
    "A029": "特殊报价10",
    //
    "A10": "内仓房",
    "A11": "海景房",
    "A12": "露台房",
    "A13": "套房",
    "A14": "补房差",
    "A15": "基本价",
    "A16": "签证费",
    "A17": "其他费用",
    "A18": "邮轮-特殊报价1",
    //
    "A20": "标准客房（正价）",
    "A21": "浪漫法式露台（正价）",
    "A22": "浪漫法式露台（提前60天）",
    "A23": "精致阳台套房（正价）",
    "A24": "精致阳台套房（提前60天）",
    "A25": "邮轮-特殊报价1",
    //
    "A40": "保费"
  },
  ProductType: {
    0: "自组",
    1: "散拼",
    2: "单项服务",
    3: "自由行",
    4: "自驾车",
    5: "游轮",
    6: "签证",
    7: "冬夏令营",
    8: "研学",
    9: "河轮",
    10: "包团-团体",
    11: "包团-散拼",
    12: "包团签证",
    13: "包团单订",
    14: "包团保险",
    15: "包团自由行",
  },
  TeamType: {
    0: "国内游",
    1: "海外游",
    2: "周边游",
    3: "港澳台",
  }
};

const mutations = {};

const actions = {


  index({commit}, view) {
    return request.PromiseCall(`${basePath}index.php`, null, view);
  },


  GetTeamDetail({commit}, view) {
    return request.PromiseCall(basePath, 'GetTeamDetail', view);
  },
  CheckInClient({commit}, view) {
    return request.PromiseCall(basePath, 'CheckInClient', view);
  },
  GetLineId({commit}, view) {
    return request.PromiseCall(basePath, 'GetLineId', view);
  },
  HotPointCacheAndLine({commit}, view) {
    return request.PromiseCall(basePath, 'HotPointCacheAndLine', view);
  },
  GetSetoutDate({commit}, view) {
    return request.PromiseCall(basePath, 'GetSetoutDate', view);
  },
  CheckSetoutDateCalendar({commit}, view) {
    return request.PromiseCall(basePath, 'CheckSetoutDateCalendar', view);
  },
  Get({commit}, view) {
    return request.PromiseCall(basePath, 'Get', view);
  },
  CheckPriceGroupAndPrice({commit}, view) {
    return request.PromiseCall(basePath, 'CheckPriceGroupAndPrice', view);
  },

};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Function/Product/Line/Team/index.js